module.exports = __webpack_public_path__ + "img/logo_冲锋狼.0969c0dd.png";